import {
  AsYouType,
  CountryCode,
  getCountryCallingCode,
} from 'libphonenumber-js'
import React from 'react'
import { useSelector } from 'react-redux'
import TextInputField, {
  TextInputFieldDesigns,
} from 'src/components/TextInputField/TextInputField'
import { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'

interface PhoneTextInputFieldProps {
  className?: string
  countryIso: string
  value?: string
  onChange: (val: string) => void
  errors?: Array<React.ReactElement | string>
  id?: string
}

const PhoneTextInputField: React.FC<PhoneTextInputFieldProps> = (
  props,
): React.ReactElement => {
  const locale = useSelector(selectNullSafeLocaleFromState)

  let formattedNumber =
    props.value !== undefined && props.value.length > 4
      ? new AsYouType(props.countryIso as CountryCode).input(props.value)
      : props.value

  // AsYouType can prepend the country calling code (e.g., "+1 " for US).
  // Strip it since the country code is shown separately in the dropdown.
  if (formattedNumber) {
    const callingCode = getCountryCallingCode(props.countryIso as CountryCode)
    if (formattedNumber.startsWith(`+${callingCode}`)) {
      formattedNumber = formattedNumber
        .slice(`+${callingCode}`.length)
        .trimStart()
    }
  }

  const onChange = (val: string): void => {
    const onlyNums = val.replace(/[^\d]/g, '')
    props.onChange(onlyNums)
  }

  return (
    <TextInputField
      className={props.className}
      id={props.id ? props.id + 'PhoneNumber' : 'phoneNumber'}
      design={TextInputFieldDesigns.New}
      placeholder={translateSingleString(locale, 'Enter full phone number')}
      value={formattedNumber}
      onChange={onChange}
      errors={props.errors}
      inputMode={'decimal'}
      testId="phone"
    />
  )
}

export default PhoneTextInputField
